import _toConsumableArray from "C:\\Users\\Kristaps\\projects\\proj261\\site\\node_modules\\@babel\\runtime\\helpers\\esm\\toConsumableArray.js";
import { useEffect } from 'react';
/**
 * Do a "hard" set on the aria, so that it's always announced
 * even if the id hasn't changed, this saves us from having to have a different id
 * per item.
 */

export var setActiveDescendant = function setActiveDescendant(ref, activeId) {
  if (!ref) return;
  ref.removeAttribute('aria-activedescendant');
  if (activeId) ref.setAttribute('aria-activedescendant', activeId);
};
export var useActiveDescendant = function useActiveDescendant(ref, id, visible, deps) {
  useEffect(function () {
    setActiveDescendant(ref.current, visible ? id : ''); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref, id, visible].concat(_toConsumableArray(deps)));
};